import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import 'chartjs-plugin-datalabels'
import {
  GenderChart,
  EmployeeTypeChart,
  LevelChart,
} from '../../../components/report/charts/headcount'
import { FONTS, COLORS } from '../../../constants'

class HeadcountToday extends React.PureComponent {
  render() {
    return (
      <Wrapper>
        <ChildWrapper width={ 50 }>
          <Chart>
            <Header>{ 'Headcount report by gender and LOB (Permanent Employee)' }</Header>
            <GenderChart
              idchart={ `genderTodays` }
              data={ get(this.props, 'genderTodays') }
            />
          </Chart>
        </ChildWrapper>
        <ChildWrapper width={ 50 }>
          <Chart>
            <Header>{ 'Headcount report by employee type and LOB' }</Header>
            <EmployeeTypeChart
              idchart={ 'empTypeTodays' }
              data={ get(this.props, 'empTypeTodays') }
            />
          </Chart>
        </ChildWrapper>
        <ChildWrapper width={ 50 }>
          <Chart>
            <Header>{ 'Headcount report by level and LOB (Permanent Employee)' }</Header>
            <LevelChart
              idchart={ 'levels' }
              data={ get(this.props, 'levels') }
            />
          </Chart>
        </ChildWrapper>
      </Wrapper>
    )
  }
}

export default HeadcountToday

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const ChildWrapper = styled.div`
  width: 50%;
  height: 100%;
`
const Header = styled.div`
  height: 40px;
  width: 100%;
  background: ${COLORS.TABLE_HEADER_COLOR};
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  padding-left: 10px;
  align-items: center;
`
const Chart = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/report/headcount/report-today.js